export default __webpack_public_path__ + "static/media/Darkblade's Leggings of Secret Doors.96dc73ef.jpg";